import React from 'react';
import Img from "./image12.png";

const Navigation = () => {
  return (
    <div className="customization-docs-screen ">
      <div className="customization-docs-screen-body">
        <h6>Navigation</h6>
        <div className="customization-docs-screen-img">
          <img src={Img} alt=""/>
        </div>
        <div>
          Accessing navigation settings can be done through two different points: the visual editor when creating a new menu, or from the customization page. This documentation is in regard to when you access navigation from the customization page.
        </div><br/>
        <div>
          You are able to create a new menu by tapping on the <b>+ Create</b> button. Previously created menus can also seamlessly be edited through this page (this includes default menus).
        </div><br/>
        <div>
          <i>All previously and recently created menus can be edited by changing their title and page.</i>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
